import React from 'react';

interface Props extends React.CSSProperties {
  src: string;
  title: string;
}

const IFrame = ({ src, title, ...props }: Props) => {
  return (
    <iframe 
      title={title}
      style={{ 
        position: 'absolute',
        top: 0,
        left: 0,
        bottom: 0,
        right: 0,
        width: '100%', height: '100%', border: 'unset', borderRadius: 20, ...props 
    }} 
      src={src}
    />
  );
};

export default IFrame;